import React from 'react'

import { SliderImages } from '@reactiveonline/frontend_shared_components'
import { getTranslatableField, constructTranslatableProductLink } from '../../helpers/utils'

export default function ServiceItem({ appProps, service, servicesPerRowClass, isOnSlider, serviceListStyle }) {

  const {
    currentLocale, defaultLocale, localeUrlPresent
  } = appProps

  const serviceImages = service.images.length > 0 ? service.images.map( image => ({
    original: image.list_view,
    thumbnail: image.thumbnail,
    fullscreen: image.banner
  })
  ) : [{
    original: 'https://storage.googleapis.com/reactive_files_eu/no-image.jpg',
    thumbnail: '',
    fullscreen: ''
  }]


  let description = getTranslatableField(service, 'description', currentLocale, false)
  if (description.length >= 50) {
    description = description.substring(0, 100) + (description.length > 100 ? '...' : '')
  }

  return (
    <div
      className={ `${ serviceListStyle || 'overlay' } ${ isOnSlider ? 'slider-service-item' : 'service-item' } pointer ${ servicesPerRowClass || '' }` }
      onClick={ () => window.location.href = constructTranslatableProductLink(service, currentLocale, defaultLocale, localeUrlPresent) }
    >
      <div className='overlay'/>

      <div className='service-image'>
        <SliderImages
          images={ serviceImages }
          showThumbnails={ false }
          showFullscreenButton={ false }
          showNav={ false }
          showBullets={ false }
          lightbox={ false }
          thumbnailPosition='bottom'
        />
      </div>

      <div className='service-text'>
        <div className='title'>
          { getTranslatableField(service, 'title', currentLocale, false) }
        </div>

        { description &&
          <div
            dangerouslySetInnerHTML={{ __html: description }}
            className='service-description'
          />
        }
      </div>

    </div>
  )
}
